import { post } from "../client";
import { EXPORT } from "../routes";

export default {
  export: async (url, data) => await post(url, data),
};
